import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import '@/App.css';
import '@/index.css';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { SoftphoneProvider } from '@/context/SoftphoneContext';
import { Toaster } from '@/components/ui/toaster';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import DidwwSettings from '@/pages/DidwwSettings';
import Dids from '@/pages/Dids';
import Extensions from '@/pages/Extensions';
import Trunks from '@/pages/Trunks';
import CallFlows from '@/pages/CallFlows';
import CallFlowEditor from '@/pages/CallFlowEditor';
import Ivr from '@/pages/Ivr';
import IvrMenu from '@/pages/IvrMenu';
import SipConnect from '@/pages/SipConnect';
import OpsDashboard from '@/pages/OpsDashboard';
import RingGroups from '@/pages/RingGroups';
import CallLogs from '@/pages/CallLogs';
import Voicemail from '@/pages/Voicemail';
import PbxConfig from '@/pages/PbxConfig';
import AuditLog from '@/pages/AuditLog';
import TollFraud from '@/pages/TollFraud';
import Users from '@/pages/Users';
import Docs from '@/pages/Docs';
import SolarGreen from '@/pages/SolarGreen';
import Queues from '@/pages/Queues';
import Conferences from '@/pages/Conferences';
import { InboundRoutes, OutboundRoutes } from '@/pages/Routes';
import TimeConditions from '@/pages/TimeConditions';
import Contacts from '@/pages/Contacts';
import ApiKeys from '@/pages/ApiKeys';
import Provisioning from '@/pages/Provisioning';
import Fayn from '@/pages/Fayn';
import Softphone from '@/pages/Softphone';
import RealtimeMonitor from '@/pages/RealtimeMonitor';
import CdrReports from '@/pages/CdrReports';
import Recordings from '@/pages/Recordings';
import Security from '@/pages/Security';
import Intercom from '@/pages/Intercom';
import Wallboard from '@/pages/Wallboard';
import TwoFactorAuth from '@/pages/TwoFactorAuth';
import HotDesking from '@/pages/HotDesking';
import TwilioSettings from '@/pages/TwilioSettings';
import TwilioPhone from '@/pages/TwilioPhone';
import TwilioInboundFlow from '@/pages/TwilioInboundFlow';

const RequireAuth = () => {
    const { user, token } = useAuth();
    const location = useLocation();
    if (!token || !user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return (
        <SoftphoneProvider>
            <Layout><Outlet /></Layout>
        </SoftphoneProvider>
    );
};

const App = () => (
    <AuthProvider>
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route element={<RequireAuth />}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/dids" element={<Dids />} />
                        <Route path="/extensions" element={<Extensions />} />
                        <Route path="/trunks" element={<Trunks />} />
                        <Route path="/call-flows" element={<CallFlows />} />
                        <Route path="/call-flows/:id" element={<CallFlowEditor />} />
                        <Route path="/ivr" element={<IvrMenu />} />
                        <Route path="/ivr-menu" element={<IvrMenu />} />
                        <Route path="/ivr-audio" element={<Ivr />} />
                        <Route path="/ops" element={<OpsDashboard />} />
                        <Route path="/ring-groups" element={<RingGroups />} />
                        <Route path="/call-logs" element={<CallLogs />} />
                        <Route path="/voicemail" element={<Voicemail />} />
                        <Route path="/pbx" element={<PbxConfig />} />
                        <Route path="/audit" element={<AuditLog />} />
                        <Route path="/toll-fraud" element={<TollFraud />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/docs" element={<Docs />} />
                        <Route path="/settings" element={<DidwwSettings />} />
                        <Route path="/solar-green" element={<SolarGreen />} />
                        <Route path="/queues" element={<Queues />} />
                        <Route path="/conferences" element={<Conferences />} />
                        <Route path="/inbound-routes" element={<InboundRoutes />} />
                        <Route path="/outbound-routes" element={<OutboundRoutes />} />
                        <Route path="/time-conditions" element={<TimeConditions />} />
                        <Route path="/contacts" element={<Contacts />} />
                        <Route path="/api-keys" element={<ApiKeys />} />
                        <Route path="/provisioning" element={<Provisioning />} />
                        <Route path="/fayn" element={<Fayn />} />
                        <Route path="/softphone" element={<Softphone />} />
                        <Route path="/sip-connect" element={<SipConnect />} />
                        <Route path="/monitor" element={<RealtimeMonitor />} />
                        <Route path="/cdr" element={<CdrReports />} />
                        <Route path="/recordings" element={<Recordings />} />
                        <Route path="/security" element={<Security />} />
                        <Route path="/intercom" element={<Intercom />} />
                        <Route path="/wallboard" element={<Wallboard />} />
                        <Route path="/2fa" element={<TwoFactorAuth />} />
                        <Route path="/hot-desking" element={<HotDesking />} />
                        <Route path="/twilio" element={<TwilioSettings />} />
                        <Route path="/twilio-phone" element={<TwilioPhone />} />
                        <Route path="/twilio-flow" element={<TwilioInboundFlow />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster />
        </div>
    </AuthProvider>
);

export default App;
